import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {Component} from "react";
import * as React from "react";
import {Card, CardBody, CardHeader} from "reactstrap";
import {withTranslation, WithTranslation} from "react-i18next";
import './NahraneSouboryPanel.scss';

/**
 * Read-only panel zobrazující seznam nahraných souborů.
 */
class NahraneSouboryPanel extends Component<WithTranslation> {

    static propTypes = {
        soubory: PropTypes.array.isRequired, // pole s názvy jednotlivých souborů
    };

    render() {
        const {soubory, t} = this.props;

        let content;
        if (soubory && Array.isArray(soubory) && soubory.length !== 0) {
            content = soubory.map((row, index) => <div key={index} className="mb-3">{row}</div>)
        } else {
            content = <i>{t('no_files')}</i>
        }

        return <Card className={"nahrane-soubory-card"}>
            <CardHeader>
                <h2>{t('uploaded_files')}</h2>
            </CardHeader>
            <CardBody>
                {content}
            </CardBody>
        </Card>
    }
}

export default connect()(withTranslation()(NahraneSouboryPanel));
